export const SET_PRESENTATION_LIST = 'SET_PRESENTATION_LIST';
export const SET_PRESENTATION_USER_NAME = 'SET_PRESENTATION_USER_NAME';

export const USER_NAME_STORAGE_KEY = 'presentation_user_name';
